import Component from '../component';

// eslint-disable-next-line no-magic-numbers
const FILE_MAX_SIZE = 1024 * 1024 * 10;
// eslint-disable-next-line no-magic-numbers
const IMAGE_MAX_SIZE = 1024 * 1024 * 10;

export default class TextEditorHelperForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$type = this.$element.data('type');
    this.$key = this.$element.data('froala-key');

    this.bindEvents();
  }

  bindEvents() {
    this.unlockFroala();
    this.startToolbar();
  }

  unbindEvents() {
    this.$element.froalaEditor('destroy');
  }

  unlockFroala() {
    $.FroalaEditor.DEFAULTS.key = this.$key;
  }

  startToolbar() {
    const config = this.froalaEditorConfig();

    if (this.$type === 'admin') {
      config.toolbarButtons.push('html');
      config.toolbarButtonsMD.push('html');
    }

    this.$element.froalaEditor(config);
  }

  froalaEditorConfig() {
    this.$element.csrfToken = $('meta[name="csrf-token"]').attr('content');

    return {
      toolbarButtons: [
        'fullscreen',
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'fontSize',
        '|',
        'color',
        'emoticons',
        'inlineStyle',
        'paragraphStyle',
        '|',
        'paragraphFormat',
        'align',
        'formatOL',
        'formatUL',
        'outdent',
        'indent',
        '-',
        'insertLink',
        'insertImage',
        'insertVideo',
        '|',
        'quote',
        'insertHR',
        'undo',
        'redo',
        'clearFormatting',
        'selectAll',
      ],
      toolbarButtonsMD: [
        'fullscreen',
        'bold',
        'italic',
        'underline',
        'color',
        'emoticons',
        'paragraphStyle',
        'paragraphFormat',
        'align',
        'formatOL',
        'formatUL',
        'outdent',
        'indent',
        'quote',
        'insertHR',
        'insertLink',
        'insertImage',
        'insertVideo',
        'undo',
        'redo',
        'clearFormatting',
      ],
      toolbarButtonsSM: [
        'fullscreen',
        'bold',
        'italic',
        'underline',
        'fontFamily',
        'insertImage',
        'emoticons',
        'undo',
        'redo',
      ],
      toolbarButtonsXS: [
        'fullscreen',
        'bold',
        'italic',
        'fontFamily',
        'fontSize',
        'emoticons',
        'undo',
        'redo',
      ],
      quickInsertButtons: ['table', 'ul', 'hr'],
      imageResizeWithPercent: true,
      imageDefaultWidth: 80,
      imageUploadURL: '/attached_files/upload',
      imageUploadMethod: 'POST',
      // eslint-disable-next-line camelcase
      imageUploadParams: {authenticity_token: this.$element.csrfToken},
      imageMaxSize: IMAGE_MAX_SIZE,
      fileUploadURL: '/attached_files/upload',
      fileUploadMethod: 'POST',
      // eslint-disable-next-line camelcase
      fileUploadParams: {authenticity_token: this.$element.csrfToken},
      fileMaxSize: FILE_MAX_SIZE,
      language: 'fr',
      imageInsertButtons: ['imageByURL', 'imageUpload'],
      videoInsertButtons: ['videoEmbed'],
    };
  }
}
